import React from 'react';

const VolumeDetails = ({ transactions }) => {
  const buyOrders = transactions.filter((order) => order.orderType === 'Buy');
  const sellOrders = transactions.filter((order) => order.orderType === 'Sell');
  const sellVolume = sellOrders.reduce((acc, order) => acc + order.amount * order.price, 0);
  const buyVolume = buyOrders.reduce((acc, order) => acc + order.amount * order.price, 0);
  const totalVolume = sellVolume + buyVolume;

  const buyCount = buyOrders.length;
  const sellCount = sellOrders.length;

  const sellPercent = (sellVolume / totalVolume) * 100;
  const buyPercent = (buyVolume / totalVolume) * 100;

  return (
    <div className="w-full max-w-xs my-8 p-4">
      <h3 className="text-lg font-semibold text-center">Volume: ${totalVolume.toLocaleString('en-US', { maximumFractionDigits: 0 })}</h3>
      <div className="relative w-full bg-red-500 rounded-full h-4 overflow-hidden my-2">
        <div
          className="bg-green-500 h-full"
          style={{ width: `${buyPercent}%` }}
        ></div>
        <div
          className="bg-red-500 h-full"
          style={{ width: `${sellPercent}%`, position: 'absolute', right: 0 }}
        ></div>
      </div>
      <div className="flex justify-between items-center text-xs mt-2">
        <div>
          <div className="text-gray-600">Buys: {buyCount}</div>
          ${buyVolume.toLocaleString('en-US', { maximumFractionDigits: 0 })} ({buyPercent.toFixed(0)}%)
        </div>
        <div>
          <div className="text-gray-600">Sells: {sellCount}</div>
          ${sellVolume.toLocaleString('en-US', { maximumFractionDigits: 0 })} ({sellPercent.toFixed(0)}%)
        </div>
      </div>
    </div>
  );
};

export default VolumeDetails;
